import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarGroup, ToolbarItem } from '@wordpress/components';
/**
 * Internal dependencies
 */

import BlockControls from '../block-controls';
import Cropper from './cropper';
import ZoomDropdown from './zoom-dropdown';
import AspectRatioDropdown from './aspect-ratio-dropdown';
import RotationButton from './rotation-button';
import FormControls from './form-controls';
export default function ImageEditor(_ref) {
  let {
    url,
    width,
    height,
    clientWidth,
    naturalHeight,
    naturalWidth
  } = _ref;
  return createElement(Fragment, null, createElement(Cropper, {
    url: url,
    width: width,
    height: height,
    clientWidth: clientWidth,
    naturalHeight: naturalHeight,
    naturalWidth: naturalWidth
  }), createElement(BlockControls, null, createElement(ToolbarGroup, null, createElement(ZoomDropdown, null), createElement(ToolbarItem, null, toggleProps => createElement(AspectRatioDropdown, {
    toggleProps: toggleProps
  })), createElement(RotationButton, null)), createElement(ToolbarGroup, null, createElement(FormControls, null))));
}
export { default as ImageEditingProvider } from './context';
//# sourceMappingURL=index.js.map